const colors = {
  primary: "#4a4a4a",
  blue: "#0e5dab",
  lightBlue: "#D4E1ED",
  error: "#c40000",
  black: "#3C3C3C",
};

export default colors;
